// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-policy-wrapper {
  display: grid;
}
.password-policy-wrapper div {
  padding-inline: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/password-policy/password-policy.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,oBAAA;EACA,aAAA;EACA,SAAA;EACA,+BAAA;AACR","sourcesContent":[".password-policy-wrapper {\n    display: grid;\n\n    div {\n        padding-inline: 1rem;\n        display: grid;\n        gap: 1rem;\n        grid-template-columns: 1fr auto;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
